/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRuler2 = createReactComponent("ruler-2", "IconRuler2", [
  ["path", { d: "M17 3l4 4l-14 14l-4 -4z", key: "svg-0" }],
  ["path", { d: "M16 7l-1.5 -1.5", key: "svg-1" }],
  ["path", { d: "M13 10l-1.5 -1.5", key: "svg-2" }],
  ["path", { d: "M10 13l-1.5 -1.5", key: "svg-3" }],
  ["path", { d: "M7 16l-1.5 -1.5", key: "svg-4" }]
]);

export { IconRuler2 as default };
//# sourceMappingURL=IconRuler2.js.map
